import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import MediaUpload from '../../../components/MediaUpload';
import BannersPreview from './BannersPreview';
import { BannerListType } from '../../../utils/Types';
import { useAppDispatch, useAppSelector } from '../../../store/redux-hooks';
import {
  bannerSelector,
  getBannerAllList,
} from '../../../features/bannerSlice';
import CenterSpinner from '../../../components/CenterSpinner';
import { API_STATUS, maxFilesInAdminSettings } from '../../../utils/Constant';
import AlertPopUP from '../../modals/AlertPopUp';
import {
  alertPopupToggle,
  onRemove,
  uploadSelectedFiles,
} from './bannerHelper';

const BannerPage: React.FunctionComponent = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [order, setOrder] = useState<string>();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showAlertPopUp, setShowAlertPopUp] = useState<boolean>(false);
  const [removeMediaId, setRemoveMediaId] = useState<any>('');
  const banners: BannerListType[] = useAppSelector(bannerSelector)?.allList;
  const apiStatus: string = useAppSelector(bannerSelector)?.allListAPIStatus;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (apiStatus === API_STATUS.FAILED || apiStatus === API_STATUS.SUCCEEDED) {
      setShowLoader(false);
    }
  }, [apiStatus]);

  useEffect(() => {
    setShowLoader(true);
    dispatch(getBannerAllList({}));
  }, []);
  return (
    <div className="ml-4">
      <Label className="text-heading">Banner</Label>
      <div className="container-parent task-item-parent-view bg-white">
        <MediaUpload
          selectedFiles={files}
          setSelectedFiles={setFiles}
          maxFiles={1}
          supportedFiles={['.svg', '.png', '.jpg', '.gif']}
          uploadFiles={(files: File[]) => {
            uploadSelectedFiles(
              files,
              order,
              setShowLoader,
              setOrder,
              setFiles,
              dispatch
            );
          }}
          showOrderInput
          order={order}
          setOrder={setOrder}
          disabled={banners?.length >= maxFilesInAdminSettings.banners}
          maxFileSizeInBytes={1024 * 1024}
        />
        <BannersPreview
          banners={banners}
          handleRemove={(id: number) => {
            onRemove(String(id), setShowAlertPopUp, setRemoveMediaId);
          }}
          keyId="homeMediaId"
          keyUrlName="homeMediaUrl"
          showPreviewImage={true}
        />
        <CenterSpinner showLoader={showLoader} className="spinner-60" />
        {showAlertPopUp && (
          <AlertPopUP
            isOpen={showAlertPopUp}
            toggle={(action: string) => {
              alertPopupToggle(
                action,
                removeMediaId,
                setShowLoader,
                dispatch,
                setShowAlertPopUp,
                setRemoveMediaId
              );
            }}
          />
        )}
      </div>
    </div>
  );
};

export default BannerPage;
